import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Account } from '../types';
import { getAccountIcon, getAccountRoleLabel, ACCOUNT_ROLE_COLORS } from '../logic/uiHelpers';
interface AccountSwitcherProps {
  accounts: Account[];
  activeAccountId: string;
  onSwitchAccount: (accountId: string) => void;
}
export function AccountSwitcher({
  accounts,
  activeAccountId,
  onSwitchAccount
}: AccountSwitcherProps) {
  return <div className="space-y-3" data-id="element-10" data-mp="1qlsmwobmwgti">
      {accounts.map((account, index) => {
      const isActive = account.id === activeAccountId;
      const Icon = getAccountIcon(account.role);
      const colors = ACCOUNT_ROLE_COLORS[account.role];
      return <motion.button key={account.id} onClick={() => onSwitchAccount(account.id)} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.05,
        duration: 0.3
      }} whileHover={{
        scale: isActive ? 1 : 1.02,
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className={`
              w-full text-left p-4 rounded-xl border-2 transition-all duration-200
              ${isActive ? `${colors.bg} ${colors.border} shadow-md` : `bg-white border-slate-200 ${colors.hoverBorder} hover:shadow-sm`}
            `} data-id="element-11" data-mp="a8m0cx696exd" data-mpi={index}>
            <div className="flex items-center gap-4" data-id="element-12" data-mp="sv1irr76aoce">
              <motion.div className={`
                  w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 transition-colors
                  ${isActive ? `${colors.iconBg} ${colors.iconText}` : 'bg-slate-100 text-slate-500'}
                `} whileHover={{
            rotate: isActive ? 0 : 5
          }} transition={{
            duration: 0.2
          }} data-id="element-13" data-mp="st88m1xcplzn">
                <Icon className="w-6 h-6" data-id="element-14" data-mp="2nl2cy448sbm8" />
              </motion.div>

              <div className="flex-1 min-w-0" data-id="element-15" data-mp="31jiu6ozqdkim">
                <div className="flex items-center gap-2 mb-1" data-id="element-16" data-mp="31h62vl831xsw">
                  <h3 className="font-bold text-slate-900 truncate" data-id="element-17" data-mp="2wj4ovepikooa">
                    {account.displayName}
                  </h3>
                  {isActive && <motion.div initial={{
                scale: 0,
                opacity: 0
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                type: 'spring',
                stiffness: 500,
                damping: 25
              }} className={`
                        flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold
                        ${colors.badgeBg} ${colors.badgeText}
                      `} data-id="element-18" data-mp="36ilszrp4aui5">
                      <Check className="w-3 h-3" data-id="element-19" data-mp="2rkxqe0t0l55" />
                      Actief
                    </motion.div>}
                </div>
                <p className="text-sm text-slate-500" data-id="element-20" data-mp="7obdt1clzgqk">
                  {getAccountRoleLabel(account.role)}
                </p>
              </div>
            </div>
          </motion.button>;
    })}
    </div>;
}